import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';

interface NonPrimitive extends Object {
  [key: string]: any;
  [index: number]: any;
}

export type MapFn = (key: string, value: any) => string;

export interface Opts {
  thisArg?: any;
}

export class DeepMapKeys {
  private cache = new WeakMap<NonPrimitive, any>();

  constructor(
    private mapFn: MapFn,
    private opts: Opts
  ) {}

  public map(value: any): any {
    return isArray(value)
      ? this.mapArray(value)
      : isObject(value)
        ? this.mapObject(value)
        : value;
  }

  private mapArray(arr: any[]): any[] {
    if (this.cache.has(arr)) {
      return this.cache.get(arr);
    }

    const length = arr.length;
    const result: any[] = [];
    this.cache.set(arr, result);

    for (let i = 0; i < length; i++) {
      result.push(this.map(arr[i]));
    }

    return result;
  }

  private mapObject(obj: NonPrimitive): NonPrimitive {
    if (this.cache.has(obj)) {
      return this.cache.get(obj);
    }

    const {
      mapFn,
      opts: { thisArg },
    } = this;
    const result: NonPrimitive = {};
    this.cache.set(obj, result);

    for (const key in obj) {
      if (key in obj) {
        result[mapFn.call(thisArg, key, obj[key])] = this.map(obj[key]);
      }
    }

    return result;
  }
}
